import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Tooltip,
    Button,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import FileSaver from "file-saver";
import XLSX from "sheetjs-style-v2"
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { IDetalheLiga, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";

import { EstatisticasService, IListaDadosMediaTimes } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridCellParams, GridColDef, GridSaveAltIcon } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { IDetalheRelatorioPagamentoPendente, RelatorioService } from "../../shered/services/api/relatorio/RelatorioService";
import { number } from "yup";
import dayjs from "dayjs";

const lstQtdRodadasFiltro = [
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 15,
        label: "15"
    },
    {
        codigo: 20,
        label: "20"
    },
    {
        codigo: 25,
        label: "25"
    },
    {
        codigo: 30,
        label: "30"
    },
    {
        codigo: 35,
        label: "35"
    },
    {
        codigo: 40,
        label: "40"
    },
    {
        codigo: 45,
        label: "45"
    },
    {
        codigo: 50,
        label: "50"
    }
    ,
    {
        codigo: 100,
        label: "100"
    }
];

const columnsGeral: GridColDef[] = [
    {
        field: 'codigo_Usuario',
        headerName: '#',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'nome_Usuario',
        headerName: 'NOME',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: 200,
        maxWidth: 200,
        headerClassName: 'super-app-theme--header',
         renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },

    {
        field: 'email_Usuario',
        headerName: 'EMAIL',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
           minWidth: 230,
       
        editable: false,
         renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'telefone_Usuario',
        headerName: 'TELEFONE',
        editable: false,
        flex: 1,
           minWidth: 180,
        maxWidth: 180,
        sortable: UtilidadeService.isMobile() ? false : true,
        headerClassName: 'super-app-theme--header',
          renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        <Grid size={{ xs: 12 }} display={"grid"} alignSelf={"center"}>
                            {params.value}
                        </Grid>

                    </Box>
                );
            },

    },
    {
        field: 'descricao_Liga',
        headerName: 'LIGA',
        editable: false,
        flex: 1,
           minWidth: 260,
        maxWidth: 260,
        sortable: UtilidadeService.isMobile() ? false : true,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'descricao_Temporada',
        headerName: 'TEMPORADA',
        editable: false,
        flex: 1,
           minWidth: 210,
        maxWidth: 210,
        sortable: UtilidadeService.isMobile() ? false : true,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
     {
        field: 'quantidade_Liga',
        headerName: 'QUANTIDADE',
        flex: 1,
        minWidth: 130,
        maxWidth: 130,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'valor',
        headerName: 'VALOR',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"

    },

];

export const ListagemDeRelPagamentoPendente: React.FC = () => {
    const theme = useTheme();
    //const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [lstLiga, setlstLiga] = useState<IDetalheLiga[]>([]);
    const [lstLigasDrop, setLstLigasDrop] = useState<ILstDrop[]>([]);
    const [dadosRelRows, setDadosRelRows] = useState<IDetalheRelatorioPagamentoPendente[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [ligaFiltro, setLigaFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });


    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                LigaService.getAllLigas()
                    .then((result) => {
                        const liga = result.dado;
                        let lstL = liga.map((f, i) => ({ codigo: f.codigo, label: f.nome }));
                        setLstLigasDrop(lstL);

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        carregarDadosRelatorio(0, 0);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosRelatorio = (codigoTemporada: number, codigoLiga: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        RelatorioService.getRelPagamentoPendente(codigoTemporada, codigoLiga)
            .then((result) => {
                const lstDados = result.dado;
                setDadosRelRows(lstDados.sort((a, b) => a.nome_Usuario > b.nome_Usuario ? 1 : -1));
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setDadosRelRows([]);
        carregarDadosRelatorio(Number(e.target.value), Number(codigoLiga));

    }



    const handleLiga = async (e: { target: { name: string; value: any; }; }) => {
        setLigaFiltro(e.target.value);
        setDadosRelRows([]);
        carregarDadosRelatorio(temporadaFiltro, Number(e.target.value));

    }

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml,sheet;charser=UTF-8";
    const fileExtension = ".xlsx";
    const exportToExcel = async (dados: IDetalheRelatorioPagamentoPendente[]) => {
        let lstExcel: IDetalheRelatorioPagamentoPendente[] = [];
        // dados.forEach(f => {
        //     const dadosExcel: IDetalheRelatorioPagamentoPendente = {
        //         nome_Completo: f.nome_Completo,
        //         cpf: f.cpf.length > 1 ?  maskCPF(f.cpf) : "-",
        //         telefone: `(${f.ddD_Telefone}) ${f.telefone}`,
        //         email: f.email,
        //         parcela: f.parcela === 1 ? "Matricula" : `Parcela ${f.parcela - 1}`,
        //         data_Pagamento: f.data_Pagamento !== "0001-01-01T00:00:00" ?  dayjs(f.data_Pagamento).format("DD/MM/YYYY") : "-",
        //         forma_Pagamento: formasPagamento.find(j => j.codigo === f.codigo_Forma_Pagamento)?.label,
        //         valor: formatNumber.format(f.valor),
        //         cidade: f.endereco.cidade,
        //         estado: f.endereco.estado,
        //         sigla: f.endereco.sigla,
        //         bairro: f.endereco.bairro,
        //         logradouro: f.endereco.logradouro,
        //         numero: f.endereco.numero,
        //         complemento: f.endereco.complemento,
        //         cep: f.endereco.cep !== undefined ? maskCEP(f.endereco.cep) : "-",
        //         codigo_Situacao: f.codigo_Situacao,
        //         data_Vencimento: dayjs(f.data_Vencimento).format("DD/MM/YYYY") ,
        //         situacao: codigoSituacaoFiltro === 6 ? statusFinanceiro.find(s => s.codigo === codigoSituacaoFiltro)?.label : statusFinanceiro.find(s => s.codigo === f.codigo_Situacao)?.label


        //     }
        //     lstExcel.push(dados);
        // })

        setIsLoading(true);
        setRemoveLoading(false);
        const ws = XLSX.utils.json_to_sheet(dados);
        const wb = { Sheets: { "data": ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `Recebimento_Faturamento_${dayjs().format("DD/MM/YYYY")}.${fileExtension}`);
        setIsLoading(false);
        setRemoveLoading(true);
    }


    return (
        <LayoutBaseDePagina
            titulo={`Relatório Pagamento Pendente`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Relatório Pagamento Pendente </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                            defaultValue={0}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Ligas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={ligaFiltro}
                                            label="Ligas"
                                            onChange={handleLiga}
                                            defaultValue={0}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstLigasDrop.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 10 }} display={"flex"} justifyContent="flex-end">
                                {dadosRelRows.length > 0 && (
                                    <Tooltip title="Exportar Time">
                                        <Button variant="outlined"
                                            onClick={() => exportToExcel(dadosRelRows)} color="primary"
                                            style={{ cursor: "pointer", height: "48px" }}
                                            endIcon={<GridSaveAltIcon />}
                                        >
                                            Exportar Relatório
                                        </Button >
                                    </Tooltip>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {dadosRelRows.length > 0 && (
                                    <Box sx={{
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                            //position: "fixed"
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .MuiDataGrid-main': {
                                            height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                            overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                        },
                                        '& .MuiDataGrid-columnHeaders ': {
                                            //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                            zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                        }
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo_Usuario}
                                            rows={dadosRelRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            // columnVisibilityModel={{
                                            //     email_Usuario: false,
                                            //     telefone_Usuario: false,

                                            // }}
                                            autoHeight
                                            getRowHeight={() => "auto"}
                                            disableDensitySelector
                                            disableVirtualization
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 11 : 16,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


